import ReactCreateClass from 'create-react-class';
import selectHelper from './selectHelper';
import AppService from 'App/legacy/AppService';

var render = function () {
	return selectHelper.getInputComponent(this);
};

var componentDidMount = function (self) {
	var sortFn =
		self.props.sortFn ||
		function (data) {
			return _.sortByOrder(data, 'name');
		};

	var opts = {
		multiple: self.props.multiple || false,
		required: self.props.required || false,
		disabled: self.props.disabled || false,
		ajax: false,
		asIds: false,
		onChange: self.props.onChange,
		idAttr: { field: 'id' },
		titleAttr: { field: 'name' },
		sorting: { field: 'name', ascending: true },
		formatSelection: obj => {
			var entity = self.props.entity;
			var objId = typeof obj === 'object' ? obj?.id : obj;
			var stage = AppService.getStages(entity, true).find(record => record.id === objId);
			if (stage) {
				return `${stage.name} (${stage.probability}%)`;
			}
			var extraValues = self.props.extraValues ?? [];
			var extra = extraValues.find(ev => String(ev.id) === String(objId));
			if (extra) {
				return extra.name;
			}
			return obj.name ?? obj;
		},
		placeholder: self.props.placeholder,
		data: function () {
			var entity = self.props.entity;
			var data = AppService.getStages(entity, true).map(record => ({
				...record,
				name: `${record.name} (${record.probability}%)`
			}));
			if (self.props.hideZeroProbability) {
				data = _.filter(data, function (stage) {
					return stage.probability > 0;
				});
			}
			const extraValues = self.props.extraValues ?? [];
			return sortFn([...data, ...extraValues]);
		}
	};

	var input = jQuery(self._input);

	selectHelper.getSelect2Options(self, opts, input, function (options) {
		input.select2(options);
	});
};

const upStages = ReactCreateClass({
	componentDidMount: function () {
		componentDidMount(this, false);
	},
	componentDidUpdate: selectHelper.updateValue,
	render: render
});

export default upStages;
